export enum EnrichmentFieldType {
  CATEGORICAL = 'categorical',
  UNIQUE = 'unique',
  EMAIL = 'email',
}

export const enrichmentFieldTypeMetaData: Record<
  EnrichmentFieldType,
  { displayName: string; description: string; icon: `mdi-${string}` }
> = {
  [EnrichmentFieldType.CATEGORICAL]: {
    displayName: 'Categorical',
    description:
      'eg. Industry, Pricing Plan, Country (participants sharing same answer)',
    icon: 'mdi-shape-plus',
  },
  [EnrichmentFieldType.UNIQUE]: {
    displayName: 'Unique',
    description: 'eg. Name, ID, Username (participants have different answers)',
    icon: 'mdi-badge-account',
  },
  [EnrichmentFieldType.EMAIL]: {
    displayName: 'Email',
    description: 'Used for sending invites, only valid emails will be saved',
    icon: 'mdi-email',
  },
};

export type CategoricalEnrichmentField = {
  name: string;
  _id: string;
  type: EnrichmentFieldType.CATEGORICAL;
  categories: {
    _id: string;
    category: string;
  }[];
};

export type UniqueEnrichmentField = {
  type: EnrichmentFieldType.UNIQUE;
  name: string;
  _id: string;
};

export type EmailEnrichmentField = {
  type: EnrichmentFieldType.EMAIL;
  name: string;
  _id: string;
};

export type EnrichmentField<Type = EnrichmentFieldType> = Extract<
  UniqueEnrichmentField | CategoricalEnrichmentField | EmailEnrichmentField,
  { type: Type }
>;

export type CreateEnrichmentFieldPayload =
  | (Omit<CategoricalEnrichmentField, '_id' | 'categories'> & {
      categories: { category: string }[];
    })
  | Omit<EmailEnrichmentField, '_id'>
  | Omit<UniqueEnrichmentField, '_id'>;
